import { useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
// import { authActions } from "../../../store/auth";
import { cuteToast } from "../../UI/cute";
import Input from "../../UI/Input";

const CloneModal = ({ cloneObj, setShowClonemodal }) => {
  const [campaign, setCampaign] = useState({
    campaign_name: "Copy - " + cloneObj.campaign_name,
    is_available: true,
    campaign_id: cloneObj.camp_id,
  });
  // eslint-disable-next-line no-unused-vars
  const [isValid, setIsValid] = useState(undefined);
  const campaignRef = useRef();
  const { sendRequest: checkCampaign } = useHttp();
  const { sendRequest: cloneCampaignRequest } = useHttp();
  const history = useHistory();
  // const dispatch = useDispatch();

  const campaignHandler = (event) => {
    const { value } = event.target;
    console.log(value);
    if (value) {
      setCampaign({ ...campaign, campaign_name: value });

      checkCampaign(
        {
          url: endPoints.checkCampaignExits,
          method: "POST",
          body: {
            name: value,
          },
        },
        (response) => {
          // console.log(campaign);

          if (response.status === 0) {
            setCampaign((prev) => {
              return {
                ...prev,
                is_available: true,
              };
            });
          } else {
            setCampaign((prev) => {
              return {
                ...prev,
                is_available: false,
              };
            });
          }
        }
      );
    } else {
      setIsValid(false);
    }
    // console.log(campaign);
  };

  useEffect(() => {
    setCampaign({
      campaign_name: "Copy - " + cloneObj.campaign_name,
      is_available: true,
      campaign_id: cloneObj.camp_id,
    });
    campaignHandlerBlur();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cloneObj]);

  const campaignHandlerBlur = () => {
    if (campaign.campaign_name) {
      checkCampaign(
        {
          url: endPoints.checkCampaignExits,
          method: "POST",
          body: {
            name: campaign.campaign_name,
          },
        },
        (response) => {
          // console.log(campaign);

          if (response.status === 0) {
            setCampaign((prev) => {
              return {
                ...prev,
                is_available: true,
              };
            });
          } else {
            setCampaign((prev) => {
              return {
                ...prev,
                is_available: false,
              };
            });
          }
        }
      );
    }
  };

  const handleSubmit = async () => {
    // dispatch(
    //   authActions.setLoaderStatus({
    //     status: true,
    //     loader_text: "",
    //   })
    // );
    // await campaignHandlerBlur();
    console.log(campaign);
    if (campaign.is_available) {
      cloneCampaignRequest(
        {
          url: endPoints.cloneCampaignRequest,
          method: "POST",
          body: {
            name: campaign.campaign_name,
            camp_id: campaign.campaign_id,
          },
        },
        (response) => {
          if (response.status === 200) {
            cuteToast({
              type: "success",
              message: "",
              timer: 5000,
              title: "Successfully Cloned",
            });
            if (response.personalize_status) {
              history.push("/video/view/" + response.camp_id);
            }

            setShowClonemodal(2);
          }
        }
      );
    }
  };

  return (
    <div
      className="modal fade show d-block"
      id="modalcreatevideo"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalcreatevideoTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="font18">Clone Campaign</h4>
            <button
              type="button"
              className="close"
              onClick={() => {
                setShowClonemodal(false);
              }}
            >
              <i
                className="fas fa-times"
                style={{ fontSize: "20px", color: "#cacccf" }}
              ></i>
            </button>
          </div>
          <div className="modal-body ">
            <div className="form-group row">
              <div className="col-sm-12">
                <label htmlFor="inputCname" className="">
                  Campaign Name
                </label>
                <Input
                  ref={campaignRef}
                  name="campaign_name"
                  type="text"
                  placeholder="Enter Campaign Name"
                  maxLength={31}
                  inputClass={`form-control ${
                    campaign.campaign_name.length >= 31 &&
                    "is-invalid max-length"
                  } ${
                    !campaign.is_available &&
                    campaign.is_available !== undefined &&
                    "is-invalid invalid"
                  } ${campaign.is_available && "is-valid"}`}
                  onChange={campaignHandler}
                  // onBlur={campaignHandlerBlur}
                  value={campaign.campaign_name}
                />

                {!campaign.is_available &&
                  campaign.is_available !== undefined && (
                    <div className={`invalid-feedback`}>Already Exist!</div>
                  )}
                {campaign.campaign_name.length >= 31 && (
                  <div className={`invalid-feedback`}>
                    Campaign Name should not be Exceeded 30 Char
                  </div>
                )}
                {campaign.is_available &&
                  campaign.campaign_name.length <= 30 && (
                    <div className={`valid-feedback`}>{"Available"}</div>
                  )}
              </div>
            </div>
            <div className="form-group row">
              {campaign.is_available && (
                <div className="col-sm-12 text-center">
                  <button className="btn" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneModal;
